var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class Cache {
    constructor() {
        this.cache = new Map();
        if (Cache.instance) {
            return Cache.instance;
        }
        Cache.instance = this;
    }
    set(key, value, ttl = 300000) {
        const expires = new Date().getTime() + ttl;
        this.cache.set(key, { value, expires });
        console.info(`Setting cache key:${key}.`);
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const cachedItem = this.cache.get(key);
            if (!cachedItem) {
                return null;
            }
            if (cachedItem && (cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.expires) > new Date().getTime()) {
                return cachedItem.value;
            }
            if (cachedItem) {
                this.cache.delete(key);
            }
            return null;
        });
    }
    clear(key) {
        this.cache.delete(key);
    }
    clearAll() {
        this.cache.clear();
    }
    keys() {
        return this.cache.keys();
    }
}
const instance = new Cache();
export default instance;
//# sourceMappingURL=cache.js.map